import React, { useEffect, useState } from 'react';
import Layout from '../../../components/Layout/Layout';
import api from '../../../api/axios';
import './SuperAdminDashboard.css';

export default function SuperAdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/dashboard').then(res => setData(res.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <Layout title="Dashboard"><div>Laden...</div></Layout>;

  return (
    <Layout title="Dashboard">
      <div className="sad-stats">
        <div className="stat-card">
          <span className="stat-value">{data?.totals?.totalCustomers ?? 0}</span>
          <span className="stat-label">Kunden</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{data?.totals?.totalTrainings ?? 0}</span>
          <span className="stat-label">Schulungen</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{data?.totals?.totalEmployees ?? 0}</span>
          <span className="stat-label">Mitarbeiter gesamt</span>
        </div>
      </div>

      <div className="card" style={{ marginTop: '1.5rem' }}>
        <h2 style={{ marginBottom: '1.25rem', fontSize: '1rem', fontWeight: 700 }}>Übersicht pro Kunde</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Kunde</th>
                <th>Mitarbeiter</th>
                <th>Schulungen</th>
                <th>Abschlussrate</th>
              </tr>
            </thead>
            <tbody>
              {data?.customers?.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight: 600 }}>{c.name}</td>
                  <td>{c.activeEmployees}</td>
                  <td>{c.activeTrainings}</td>
                  <td>
                    <div className="progress-bar-wrapper">
                      <div className="progress-bar">
                        <div className="progress-fill" style={{ width: `${c.usageRate}%` }} />
                      </div>
                      <span className="progress-label">{c.usageRate}%</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
